import * as React from "react";
import type { ChangeEvent, FocusEvent } from "react";

import classNames from "classnames/bind";

import styles from "./RadioButton.module.scss";

const cx = classNames.bind(styles);

export interface RadioButtonProps {
    label?: string;
    id?: string;
    name?: string;
    value?: string | number;
    checked?: boolean;
    className?: string;
    disabled?: boolean;
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    onFocus?: (e: FocusEvent<HTMLInputElement>) => void;
    onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
    autofocus?: boolean;
    defaultChecked?: boolean;
    isAutoCompleteOff?: boolean;
}

const RadioButton = React.forwardRef<HTMLInputElement, RadioButtonProps>(
    (props: RadioButtonProps, ref) => {
        const { label, id = "radio", className, isAutoCompleteOff = true, ...rest } = props;

        const handleOnChange = rest?.onChange ? rest.onChange : () => {};

        const attrs = {
            ...rest,
            id,
            type: "radio",
            className: cx("input"),
            autoComplete: isAutoCompleteOff ? "off" : "on",
            ref,
        };

        const Label = !label ? "div" : "label";

        return (
            <Label className={cx("container", className)} data-checked={rest.checked} tabIndex={0}>
                <input {...attrs} onChange={handleOnChange} tabIndex={-1} />
                {label && <span className={cx("label")}>{label}</span>}
            </Label>
        );
    }
);

RadioButton.displayName = "RadioButton";

export default RadioButton;
